import React, { useEffect, useRef, useState } from 'react';
import { Card, List, Input, Button, Typography, Avatar, message, Spin, Image } from 'antd';
import { UserOutlined, RobotOutlined, CloseCircleFilled } from '@ant-design/icons';
import { getAccessTokenForDialogflow, postRequest } from '../../helpers/apiCall';
import aicon from '../../assets/images/a-icon.jpg';
import axios from 'axios';
import { createMarkup } from '../../helpers/functions';
import TextDisplayModal from './TextDisplayModal';
import { useParams } from 'react-router-dom';
const { Text } = Typography;

const RecommendedExpertChatBot = ({
  setShowChatBot,
  messages,
  setMessages,
  query,
  fromInputBox,
  setFromInputBox,
  displayRecommendations,
}) => {
  const [inputValue, setInputValue] = useState(query || '');
  const [loading, setLoading] = useState(false);
  const [accessToken, setAccessToken] = useState('');
    const { qid } = useParams();

  const fetchToken = async () => {
    try {
      const token = await getAccessTokenForDialogflow();
      setAccessToken(token);
      localStorage.setItem('dialogflowAccessToken', token);
    } catch (error) {
      console.error('Failed to get access token:', error);
    }
  };
  const handleSend = async () => {
    if (!inputValue.trim()) return;

    const userMessage = { sender: 'user', text: inputValue };
    setMessages(prev => [...prev, userMessage]);
    setInputValue('');
    setLoading(true);
    const sessionId = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
    const dialogflowEndpoint = `https://dialogflow.googleapis.com/v2beta1/projects/accountizer-bot-436506/agent/sessions/${sessionId}:detectIntent`;
    try {
      const response = await axios.post(
        dialogflowEndpoint,
        {
          queryInput: {
            text: {
              text: inputValue,
              languageCode: 'en',
            },
          },
          queryParams: {
            knowledgeBaseNames: [
              'projects/accountizer-bot-436506/knowledgeBases/MTgzOTY5NDM2MTg2NzQ3ODYzMDU',
            ],
          },
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      if (response?.data?.queryResult?.knowledgeAnswers?.answers?.[0]?.matchConfidence > 0.8) {
        const botMessage = {
          sender: 'Accountizer',
          text: response?.data?.queryResult?.knowledgeAnswers?.answers?.[0]?.answer,
        };
        setMessages(prev => [...prev, botMessage]);
        return;
      }
      const resp = await postRequest('AgenticRecommendationservice', {
        information: inputValue,
        question_id: qid,
      });

      const botMessage = {
        sender: 'Accountizer',
        text:
          resp?.data?.result || 'This question is out of my context. Please rephrase your question',
      };
      setMessages(prev => [...prev, botMessage]);
    } catch (error) {
      message.error('Something went wrong. Please try again.');
      setMessages(prev => [
        ...prev,
        {
          sender: 'Accountizer',
          text: 'This question is out of my context. Please rephrase your question',
        },
      ]);
      fetchToken();
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') handleSend();
  };
  useEffect(() => {
    if (localStorage.getItem('dialogflowAccessToken')) {
      setAccessToken(localStorage.getItem('dialogflowAccessToken'));
    } else {
      fetchToken();
    }
  }, []);
  useEffect(() => {
    if (accessToken && fromInputBox) {
      handleSend();
    }
  }, [accessToken]);
  const [showEvalReportId, setShowEvalReportId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // useEffect(() => {
  //   if (showEvalReportId) {
  //     setIsModalVisible(true);

  //   }
  // }, [showEvalReportId]);

  const formatMessageText = text => {
    return text.replace(
      /<span id=["']?(\d+)["']?>/g,
      (_, id) =>
        `<span id="${id}" class="clickable-span" style="color:blue; cursor:pointer;">`
    );
  };
  const listRef = useRef(null);

  useEffect(() => {
    // Delegate event listener to clickable spans
    const handleClick = (e) => {

      if (e.target.classList.contains("clickable-span")) {

        const id = e.target.id;
        setShowEvalReportId(id);
        setIsModalVisible(true);
      }
    };

    const container = listRef.current;

    if (container) {
      container.addEventListener("click", handleClick);
    }


  }, []);
  return (
    <Card
      style={{ display: 'flex', flexDirection: 'column', marginTop: '2rem', position: 'relative' }}
    >
      {isModalVisible && (
        <TextDisplayModal
          visible={isModalVisible}
          setVisible={setIsModalVisible}
          content={displayRecommendations.find(el => el.id == showEvalReportId)?.description}
          title={`${displayRecommendations.find(el => el.id == showEvalReportId)?.first_name}'s Evaluation Report`}
        />
      )}

      <Button
        type="link"
        style={{ position: 'absolute', top: '5px', right: '5px', cursor: 'pointer' }}
        onClick={() => {
          setMessages([]);
          setShowChatBot(false);
          setFromInputBox(false);
        }}
        disabled={loading}
      >
        Back to suggestions
      </Button>
      <div ref={listRef} style={{ flex: 1, marginBottom: 16 }}>
        <List
          dataSource={messages}
          locale={{ emptyText: 'No messages yet' }}
          renderItem={item => {
            const isUser = item.sender === 'user';
            const formattedHtml = formatMessageText(item.text);

            return (
              <List.Item >
                <List.Item.Meta
                  style={{
                    textAlign: isUser ? 'end' : 'start',
                    flexDirection: isUser ? 'row-reverse' : 'row',
                    alignItems: 'baseline'
                  }}
                  avatar={
                    isUser ? (
                      <Avatar icon={<UserOutlined />} style={{ margin: '10px' }} />
                    ) : (
                      <Avatar src={aicon} width={30} height={30} alt="" style={{ border: '1px solid lightgray' }} />
                    )
                  }
                  // title={<Text strong>{isUser ? 'You' : 'Accountizer'}</Text>}
                  description={<div style={{ color: 'black', backgroundColor: isUser ? 'lightgray' : '#f6ffed', borderRadius: '12px', padding: '12px 16px', maxWidth: 'fit-content', marginLeft: isUser ? 'auto' : 0, marginRight: isUser ? 0 : 'auto', boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }} dangerouslySetInnerHTML={{ __html: formattedHtml }} />}
                />
              </List.Item>
            );
          }}
        />

        {loading && (
          <div style={{ textAlign: 'center', padding: 10 }}>
            <Spin size="small" tip="Bot is typing..." />
          </div>
        )}
      </div>

      <Input.Group compact>
        <Input
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          style={{ width: '90%' }}
          placeholder="Type a message"
          disabled={loading}
        />
        <Button
          style={{ width: '10%' }}
          type="primary"
          onClick={handleSend}
          loading={loading}
          disabled={loading}
        >
          Send
        </Button>
      </Input.Group>
    </Card>
  );
};

export default RecommendedExpertChatBot;
